<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import { onBeforeMount, ref, Ref, computed } from "vue";
import IntegrationDO = App.Data.Integrations.IntegrationDO;
import { useApiClient } from "@/api/client";
import { useRoute } from "vue-router";

const integration = ref<IntegrationDO | undefined>(undefined);
const integrationUuid: string = String(useRoute().params.uuid) ?? "";

const breadcrumbs = ref([
	{
		title: "Integrations",
		disabled: false,
		to: "/integrations",
	},
]);

const tabs = computed(() => [
	{
		itemId: "activity",
		translationKey: "integrations.detail.activity",
		icon: "fa: fa-light fa-wave-pulse",
		to: `/integrations/manage/${integration.value?.uuid ?? "n-a"}/activity`,
	},
	{
		itemId: "configuration",
		translationKey: "integrations.detail.configuration",
		icon: "fa: fa-light fa-handshake",
		to: `/integrations/manage/${
			integration.value?.uuid ?? "n-a"
		}/configuration`,
	},
]);

const getIntegration = async () => {
	const response = await useApiClient("integrations").show(integrationUuid);

	if (response.isOk()) {
		integration.value = response.value;
		breadcrumbs.value.push({
			title: integration.value.company_name,
			disabled: true,
			to: `/integrations/manage/${integration.value?.uuid}`,
		});
	}
};

onBeforeMount(() => getIntegration());

const activeTab = ref(null);
</script>

<template>
	<main-breadcrumbs :breadcrumbs="breadcrumbs" icon="fa-people-group" />

	<v-tabs v-model="activeTab" class="rounded-md">
		<v-tab
			v-for="(tab, index) in tabs"
			:value="tab.itemId"
			color="primary"
			:to="tab.to"
			:key="index"
			:prepend-icon="tab.icon"
		>
			{{ $t(tab.translationKey) }}
		</v-tab>
		<v-spacer />
		<div class="mt-2 mr-2">
			<v-chip
				label
				v-if="integration?.is_configured_correctly ?? false"
				color="success"
				prepend-icon="fa: fa-light fa-link"
				>Connected</v-chip
			>
			<v-chip
				label
				v-else
				color="warning"
				prepend-icon="fa: fa-light fa-link-slash"
				>Not Connected</v-chip
			>
		</div>
	</v-tabs>
	<v-divider />
	<div class="mt-5">
		<router-view :integration="integration" />
	</div>
</template>

<style lang="scss"></style>
